import { render } from "./SelectLocation.vue?vue&type=template&id=711343dd"
import script from "./SelectLocation.vue?vue&type=script&lang=js"
export * from "./SelectLocation.vue?vue&type=script&lang=js"
script.render = render

export default script